const baseURL = 'https://api-service.vanceai.com/web_api/v1';

const VANCE_FILTER_CONFIG = Object.freeze({
    cartoonize: {
        job: 'cartoonize',
        config: {
            module: 'cartoonize',
            module_params: { model_name: 'CartoonizeStable' }
        }
    },
    anime: {
        job: 'animegan',
        config: {
            module: 'animegan2',
            module_params: {
                model_name: 'Animegan2Stable',
                single_face: true
            }
        }
    }
});

export const VANCE_ERROR_CODE = Object.freeze({
    invalid_token: 30001,
    insufficient_credits: 30004,
    internal_error: 10010
});

const VANCE_JOB_STATUS = Object.freeze({
    finish: 'finish',
    waiting: 'waiting',
    process: 'process',
    fatal: 'fatal'
});

const vanceApiRequest = (params, endpoint, responseType = 'json') => {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();

        request.onload = () => {
            if (request.status != 200) return reject(request);
            else if (request.response.code && request.response.code != 200) {
                return reject({
                    msg: request.response.msg,
                    code: request.response.code
                });
            }

            return resolve(request.response.data || request.response);
        };

        request.open('POST', `${baseURL}/${endpoint}`);
        request.responseType = responseType;
        request.send(params);
    });
};

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ImageFiltersAPIService', imageFiltersAPIService);

    function imageFiltersAPIService() {
        const uploadImage = (key, image) => {
            const params = new FormData();
            params.append('api_token', key);
            params.append('file', image);

            return vanceApiRequest(params, 'upload');
        };

        const transformImage = (key, imageId, config = VANCE_FILTER_CONFIG.anime) => {
            const params = new FormData();
            params.append('api_token', key);
            params.append('uid', imageId);
            params.append('jconfig', JSON.stringify(config));

            return vanceApiRequest(params, 'transform');
        };

        const downloadTransformedImage = (key, transformId) => {
            const params = new FormData();
            params.append('api_token', key);
            params.append('trans_id', transformId);
            return vanceApiRequest(params, 'download', 'blob');
        };

        const checkVanceJobStatus = (key, transformId) => {
            const params = new FormData();
            params.append('api_token', key);
            params.append('trans_id', transformId);
            return vanceApiRequest(params, 'progress');
        };

        const handleJobResponse = async (key, transformId, jobStatus) => {
            switch (jobStatus) {
                case VANCE_JOB_STATUS.finish:
                    return;
                case VANCE_JOB_STATUS.fatal:
                    throw 'There seems to be an error with VanceAI. Please try again or contact VanceAI support.';
                case VANCE_JOB_STATUS.waiting:
                case VANCE_JOB_STATUS.process:
                    await new Promise((res) => setTimeout(res, 200));
                    const { status } = await checkVanceJobStatus(key, transformId);
                    await handleJobResponse(key, transformId, status);
                    break;
            }
        };

        const cartoonizeImage = async (key, image) => {
            let promiseResolve, promiseReject;
            const promise = new Promise((resolve, reject) => {
                promiseResolve = resolve;
                promiseReject = reject;
            });
            try {
                const { uid: vanceImageId } = await uploadImage(key, image);
                const { trans_id, status } = await transformImage(key, vanceImageId);
                await handleJobResponse(key, trans_id, status);
                const processedImage = await downloadTransformedImage(key, trans_id);
                promiseResolve(processedImage);
            } catch (error) {
                promiseReject(error);
            }

            return promise;
        };

        return { cartoonizeImage };
    }
})();
